import Vue from 'vue';
import VueRx from 'vue-rx';
import axios from 'axios';
import { ModalPlugin, ToastPlugin } from 'bootstrap-vue';
import App from './App.vue';
import router from './router';
import store, { SET_USER } from './store';

Vue.config.productionTip = false;

Vue.use(VueRx);
Vue.use(ModalPlugin);
Vue.use(ToastPlugin);

const isFromSameAuthSession = (to, from) => from.meta.auth && to.meta.role === from.meta.role;

const requireLogin = (to, from, next, path) => {
  if (!to.meta.auth) {
    next({
      path,
      query: {
        redirect: to.fullPath,
      },
    });
  }
};

const authGuard = async (to, from, next) => {
  if (to.path === '/tnc') {
    next();
    return;
  }
  if (to.path.indexOf('/brandCreator') === 0) {
    next();
    return;
  }
  if (to.path.indexOf('/rewardRedemption') === 0) {
    next();
    return;
  }
  if (to.path.indexOf('/qr-scanner') === 0) {
    const user = {
      token: localStorage.getItem('token'),
      username: localStorage.getItem('username'),
      role: localStorage.getItem('role'),
      id: localStorage.getItem('id'),
    };
    try {
      const {
        data: { payload },
      } = await axios.get(
        '/agc-sub-merchant-api/auth/validateToken',
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
            username: user.username,
          },
        },
      );
      if (payload || (user.token && user.username && user.role)) {
        store.commit(SET_USER, user);
        next();
      } else {
        requireLogin(to, from, next, '/qr-scanner/subMerchantLogin');
      }
    } catch (e) {
      requireLogin(to, from, next, '/qr-scanner/subMerchantLogin');
    }
    next();
  } else {
    if (!store.state.user && !isFromSameAuthSession(to, from)) {
      let authUrl;
      let loginPath;
      if (to.path.indexOf('/admin') === 0) {
        authUrl = '/agc-admin-api/auth';
        loginPath = '/admin/login';
      } else if (to.path.indexOf('/sale') === 0) {
        authUrl = '/agc-sale-api/auth';
        loginPath = '/sale/login';
      } else {
        authUrl = '/agc-merchant-api/auth';
        loginPath = '/login';
      }
      try {
        const {
          data: { payload },
        } = await axios.get(authUrl);
        if (payload) {
          store.commit(SET_USER, payload);
        } else {
          requireLogin(to, from, next, loginPath);
        }
      } catch (e) {
        requireLogin(to, from, next, loginPath);
      }
    }
    if (store.state.user && to.meta.auth) {
      const { role } = store.state.user;
      if (role === 'admin') {
        next({ path: '/admin' });
      }
      if (role === 'sale') {
        next({ path: '/sale' });
      }
      if (role === 'merchant') {
        next({ path: '/' });
      }
      if (role === 'sub-merchant') {
        next({ path: '/qr-scanner' });
      }
    }
    next();
  }
};

router.beforeEach(authGuard);
router.afterEach((to, form) => {
  const isInitLoad = form.path === '/' && form.name === null;
  window.ga('send', 'pageview', `/agc${to.path}`);
  if (!isInitLoad) {
    let screen = 'NA';
    if (to.path === '/brandCreator') {
      screen = 'mc_apply';
    } else if (to.path === '/rewardRedemption') {
      // Send pageview at rewardRedemption page
      return;
    }

    window.dataLayer.push({
      event: 'ultriggerpageview',
      ga4: {
        channel: 'www',
        event_name: 'page_view',
        title: 'NA',
        content: {
          id: 'NA',
          type: 'NA',
        },
        video: {
          program: 'NA',
        },
        author: 'NA',
        taglist: 'NA',
        service: 'merchant',
        category: 'NA',
        publishdate: 'NA',
        primary: {
          main: 'NA',
          sub: 'NA',
        },
        pageurl: window.location.href,
        screen,
        text: 'NA',
      },
      _clear: true,
    });
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
  mounted() {
    if (window.location.pathname !== '/merchantcenter/rewardRedemption') {
      document.querySelector('#init-loading').style.display = 'none';
    }
  },
}).$mount('#app');
